(function() {
  'use strict';

  // Sticky header
  var header = document.getElementById('site-header');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var cur = window.pageYOffset;
      if (cur > 80) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
      lastScroll = cur;
    }, { passive: true });
  }

  // Search toggle
  var searchToggle = document.getElementById('search-toggle');
  var searchBar = document.getElementById('search-bar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      var isOpen = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        setTimeout(function() { searchBar.querySelector('input').focus(); }, 100);
      }
    });
  }

  // Mobile menu
  var hamburger = document.getElementById('hamburger-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileClose = document.getElementById('mobile-close');
  var overlay = document.getElementById('overlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  // Mobile submenu toggles
  document.querySelectorAll('.mobile-menu__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.mobile-menu__item');
      if (item) item.classList.toggle('is-expanded');
    });
  });

  // Hero slideshow
  var heroSection = document.querySelector('.hero-slideshow');
  if (heroSection) {
    var slides = heroSection.querySelectorAll('.hero-slide');
    var dots = heroSection.querySelectorAll('.hero-slideshow__dot');
    var prevBtn = heroSection.querySelector('.hero-slideshow__prev');
    var nextBtn = heroSection.querySelector('.hero-slideshow__next');
    var current = 0;
    var total = slides.length;
    var autoplayInterval;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (idx + total) % total;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function startAutoplay() {
      autoplayInterval = setInterval(function() { goTo(current + 1); }, 5000);
    }
    function stopAutoplay() { clearInterval(autoplayInterval); }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); goTo(current + 1); startAutoplay(); });
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { stopAutoplay(); goTo(i); startAutoplay(); });
    });

    var touchStartX = 0;
    heroSection.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    heroSection.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { stopAutoplay(); goTo(diff > 0 ? current + 1 : current - 1); startAutoplay(); }
    });

    if (total > 1) startAutoplay();
  }

  // Product gallery
  var galleryMain = document.getElementById('gallery-main');
  if (galleryMain) {
    var mainSlides = galleryMain.querySelectorAll('.product-gallery__slide');
    var thumbBtns = document.querySelectorAll('.product-gallery__thumb');
    thumbBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.index, 10);
        mainSlides.forEach(function(s) { s.classList.remove('is-active'); });
        thumbBtns.forEach(function(b) { b.classList.remove('is-active'); });
        mainSlides[idx].classList.add('is-active');
        btn.classList.add('is-active');
      });
    });
  }

  // Variant selection
  var productForm = document.getElementById('product-form');
  if (productForm) {
    var optionBtns = productForm.querySelectorAll('.option-btn');
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.dataset.optionIndex;
        var group = productForm.querySelectorAll('[data-option-index="' + idx + '"] .option-btn');
        group.forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var valEl = productForm.querySelector('#option-val-' + (parseInt(idx, 10) + 1));
        if (valEl) valEl.textContent = btn.dataset.value;
      });
    });
  }

  // Quantity selectors
  function initQtySelectors(container) {
    (container || document).querySelectorAll('.qty-selector').forEach(function(sel) {
      var input = sel.querySelector('.qty-selector__input');
      sel.querySelectorAll('.qty-selector__btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = parseInt(input.value, 10) || 1;
          input.value = btn.dataset.qty === 'plus' ? val + 1 : Math.max(1, val - 1);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }
  initQtySelectors();

  // AJAX add to cart
  function addToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) { console.error('Cart error:', data.description); return; }
      updateCartCount();
      showCartNotification();
      if (callback) callback(data);
    })
    .catch(function(err) { console.error('Cart error:', err); });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }

  var cartNotification = document.getElementById('cart-notification');
  var notifCloseBtn = cartNotification ? cartNotification.querySelector('.cart-notification__close') : null;
  var notifTimeout;

  function showCartNotification() {
    if (window.__openCartDrawer) { window.__openCartDrawer(); return; }
    if (!cartNotification) return;
    cartNotification.setAttribute('aria-hidden', 'false');
    cartNotification.classList.add('is-visible');
    clearTimeout(notifTimeout);
    notifTimeout = setTimeout(function() { hideCartNotification(); }, 4500);
  }
  function hideCartNotification() {
    if (!cartNotification) return;
    cartNotification.setAttribute('aria-hidden', 'true');
    cartNotification.classList.remove('is-visible');
  }
  if (notifCloseBtn) notifCloseBtn.addEventListener('click', hideCartNotification);

  // Quick add
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-card__quick-add');
    if (btn) {
      e.preventDefault();
      btn.classList.add('is-loading');
      addToCart(btn.dataset.productId, 1, function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function() { btn.classList.remove('is-added'); }, 2000);
      });
    }
  });

  // Product form ATC
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = productForm.querySelector('#variant-id').value;
      var quantity = parseInt(productForm.querySelector('.qty-selector__input').value, 10) || 1;
      var btn = document.getElementById('add-to-cart-btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Agregando...'; }
      addToCart(variantId, quantity, function() {
        if (btn) {
          btn.disabled = false;
          btn.textContent = '\u2713 Agregado al carrito';
          setTimeout(function() { btn.textContent = 'Agregar al carrito'; }, 2500);
        }
      });
    });
  }

  // Cart item update/remove
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount();
      if (quantity === 0) {
        var item = document.querySelector('[data-key="' + key + '"]');
        if (item) item.remove();
      }
      var subtotalEl = document.getElementById('cart-subtotal');
      var totalEl = document.getElementById('cart-total');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    });
  }

  document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('.cart-qty-minus');
    var plusBtn = e.target.closest('.cart-qty-plus');
    var removeBtn = e.target.closest('.cart-item__remove');
    if (minusBtn) {
      var inp = document.querySelector('.cart-qty-input[data-key="' + minusBtn.dataset.key + '"]');
      var qty = Math.max(0, parseInt(inp.value, 10) - 1);
      inp.value = qty; updateCartItem(minusBtn.dataset.key, qty);
    }
    if (plusBtn) {
      var inp2 = document.querySelector('.cart-qty-input[data-key="' + plusBtn.dataset.key + '"]');
      var qty2 = parseInt(inp2.value, 10) + 1;
      inp2.value = qty2; updateCartItem(plusBtn.dataset.key, qty2);
    }
    if (removeBtn) { updateCartItem(removeBtn.dataset.key, 0); }
  });

  // Product tabs
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabId = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('is-active'); });
      document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var panel = document.getElementById('tab-' + tabId);
      if (panel) panel.classList.add('is-active');
    });
  });

  // Testimonials slider
  var testimonialsSlider = document.getElementById('testimonials-slider');
  if (testimonialsSlider) {
    var testimonialTrack = testimonialsSlider.querySelector('.testimonials__track');
    var tPrev = document.querySelector('.testimonials__prev');
    var tNext = document.querySelector('.testimonials__next');
    var tCurrent = 0;
    var tCards = testimonialsSlider.querySelectorAll('.testimonial-card');
    var tVisible = window.innerWidth < 768 ? 1 : (window.innerWidth < 1024 ? 2 : 3);
    var tMax = Math.max(0, tCards.length - tVisible);
    function scrollTestimonials(dir) {
      tCurrent = Math.max(0, Math.min(tMax, tCurrent + dir));
      var cardWidth = tCards[0] ? tCards[0].offsetWidth + 24 : 300;
      if (testimonialTrack) testimonialTrack.style.transform = 'translateX(-' + (tCurrent * cardWidth) + 'px)';
    }
    if (tPrev) tPrev.addEventListener('click', function() { scrollTestimonials(-1); });
    if (tNext) tNext.addEventListener('click', function() { scrollTestimonials(1); });
  }

  // Collection filter sidebar
  var filterToggle = document.getElementById('filter-toggle');
  var filterSidebar = document.getElementById('filter-sidebar');
  var filterClose = document.getElementById('filter-close');
  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', function() {
      filterSidebar.classList.toggle('is-open');
      if (overlay) overlay.classList.toggle('is-active');
    });
  }
  if (filterClose) {
    filterClose.addEventListener('click', function() {
      if (filterSidebar) filterSidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-active');
    });
  }

  // Filter accordion
  document.querySelectorAll('.filter-group__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var content = btn.nextElementSibling;
      var expanded = btn.getAttribute('aria-expanded') !== 'false';
      btn.setAttribute('aria-expanded', !expanded);
      if (content) content.style.display = expanded ? 'none' : '';
    });
  });

  // Discount code
  var applyDiscount = document.getElementById('apply-discount');
  if (applyDiscount) {
    applyDiscount.addEventListener('click', function() {
      var code = document.getElementById('discount-code').value.trim();
      if (code) window.location.href = '/discount/' + code;
    });
  }

  // Scroll animations
  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.product-card, .category-card, .testimonial-card, .trust-badge').forEach(function(el) {
      el.classList.add('animate-on-scroll');
      animObserver.observe(el);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' MXN';
  }

  updateCartCount();

})();
